import _ from 'lodash'

class Gate {
    role (role) {
        return !!_.preload(`${role}.data.uuid`)
    }
}

export default new Gate()
